import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { Text, Modal, ModalContent, ModalFooter, ModalHeader, Button } from "@netapp/bxp-design-system-react";
import _ from "lodash";
import { allMenus as i18nNamespace } from "../../../../../../i18n/namespace";

const RoleElevationChangeConfirmationModal = ({ isUserRequestingElevation, OnConfirmationCancel, OnConfirmationOk }) => {
    const dispatch = useDispatch();
    const userName = useSelector(state => state.auth.name);
    const [error, setError] = useState(undefined);
    const { orgId, userId, isLoading } = useSelector(state => ({
        orgId: state.tenancy.selectedOrgId,
        userId: state.tenancy.user?.id,
        isLoading: state.tenancy.isLoading
    }));
    const { t } = useTranslation(i18nNamespace);
    const modalTextMap = isUserRequestingElevation ? { title: t('elevate'), text: t('areYouSureElevate'), desc: t('elevateModedesc'), btnText: t('elevate') } :
        { title: t('downscope'), text: t('areYouSureDownscope'), desc: t('downscopeModedesc'), btnText: t('downscope') }

    const modifyUserAccess = () => {
        dispatch({
            type: "TENANCYV4:TOGGLE-USER-ACCESS-SAFE-MODE",
            payload: {
                selectedOrgId: orgId,
                selectedUserId: userId,
                elevatedStateDesired: isUserRequestingElevation
            }
        }).then((response) => {
            const isUserAccessElevated = response?.elevatedStateDesired;
            const successMsg = isUserAccessElevated ? <Trans i18nKey="user_elevate_status" t={t} values={{ userName: userName }} components={{ strong: <strong /> }} />
                : <Trans i18nKey="user_downscoped_status" t={t} values={{ userName: userName }} components={{ strong: <strong /> }} />;
            dispatch({
                type: "NOTIFICATIONS:SUCCESS",
                payload: {
                    message: successMsg,
                    showGlobal: true
                }
            })
            OnConfirmationOk();
        }).catch((ex) => {
            setError(ex?.errMessage);
        });
    };
    
    return (
        <Modal>
            <ModalHeader>{modalTextMap.title}</ModalHeader>
            <ModalContent>
                <Text>{modalTextMap.text}</Text>
                <Text>{modalTextMap.desc}</Text>
            </ModalContent>
            <ModalFooter error={error}>
                <Button onClick={() => modifyUserAccess()} isSubmitting={isLoading}>{modalTextMap.btnText}</Button>
                <Button color="secondary" onClick={OnConfirmationCancel}>{t('cancel')}</Button>
            </ModalFooter>
        </Modal>
    );
}
export default RoleElevationChangeConfirmationModal;